// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container__2l_ft","isMine":"Message_isMine__2thi2","start":"Message_start__21LNV","messageBox":"Message_messageBox__3Z0nz","end":"Message_end__HMZGU"};